import { useCallback, useState } from "react";

// Yoğun veri tabloları için kolon görünürlüğü + satır yoğunluğu tercihleri.
// Tarayıcıda (localStorage) kalıcıdır; ekran/tablo başına ayrı anahtar kullanır.
// cols: [{ key, label, locked? }]  — locked kolonlar her zaman görünür kalır.
export function useTablePrefs(key, cols) {
  const storeKey = "groot_tableprefs_" + key;
  const build = useCallback((raw) => {
    const vis = {};
    cols.forEach((c) => {
      vis[c.key] = c.locked ? true : (raw?.visible ? raw.visible[c.key] !== false : true);
    });
    return { visible: vis, density: raw?.density === "compact" ? "compact" : "comfortable" };
  }, [cols]);

  const [state, setState] = useState(() => {
    try { return build(JSON.parse(localStorage.getItem(storeKey) || "null")); }
    catch { return build(null); }
  });

  const commit = useCallback((next) => {
    setState(next);
    try { localStorage.setItem(storeKey, JSON.stringify(next)); } catch { /* yoksay */ }
  }, [storeKey]);

  const toggle = useCallback((k) => {
    const col = cols.find((c) => c.key === k);
    if (col?.locked) return;
    setState((s) => {
      const next = { ...s, visible: { ...s.visible, [k]: !s.visible[k] } };
      try { localStorage.setItem(storeKey, JSON.stringify(next)); } catch { /* yoksay */ }
      return next;
    });
  }, [cols, storeKey]);

  const setDensity = useCallback((d) => setState((s) => {
    const next = { ...s, density: d === "compact" ? "compact" : "comfortable" };
    try { localStorage.setItem(storeKey, JSON.stringify(next)); } catch { /* yoksay */ }
    return next;
  }), [storeKey]);

  const reset = useCallback(() => commit(build(null)), [commit, build]);

  return { visible: state.visible, density: state.density, toggle, setDensity, reset };
}

export default useTablePrefs;
